export default class SlideoutMenu {
    /**
     *  Animate the menu tooltip
     */
    static show() {
        const $body = $('body');
        if ($body.hasClass('pinned')) {
            return;
        }
        $body.addClass('sidebar-open');
    }

    /**
     *  Remove the tooltip once mouse leaves
     */
    static hide() {
        const $body = $('body');
        if ($body.hasClass('pinned')) {
            return;
        }
        $body.removeClass('sidebar-open');
    }

    /**
     *  Set Events function
     */
    static init() {
        const $body = $('body');
        $('#sidebar')
            .on('mouseenter', function () {
                SlideoutMenu.show();
            })
            .on('mouseleave', function () {
                SlideoutMenu.hide();
            });
        $('#header .hamburger a').on('click', function () {
            $body.toggleClass('pinned');
            localStorage.setItem('aero:menu:pinned', $body.hasClass('pinned') ? '1' : '0');
        });

        if (localStorage.getItem('aero:menu:pinned') === '1') {
            $body.addClass('pinned');
        }
    }
}
